module.exports = "data:image/webp;base64,UklGRgoBAABXRUJQVlA4IP4AAAAwBgCdASoZABkAPpFAmEmlo6IhKAqosBIJQBbZ3gascpXvBlABvnEwp/cU6av4UJvJfxpkwnVP/NWgAP6lTcEQpiasiDbIdOGH5XfYpMTRy03UG8nPIkp6TsrlGyuxcbxfZ5uWzm19oTLDtJ/h93vIZ/ri5sgYf/EOf4Ff6VsZDF1+SNosb7FHusvRW1WmoQBzTBvRUsNPkV8W+2pzV9IlzP4rH0WWA829AwqCqiTmxrvvuupp6hREetp3f2LEqTeAroQeMx4rN/QGCI6jUScvFUVQgZUvFWnV3qiANqDRMal3k7CW4JDpD2um8+cvtW0kycEpovALpXAEisPAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/wine.webp
// module id = RKLK
// module chunks = 14